import * as zod from 'zod';

export const EtherNetIPEDSFileData = zod.object({
  content: zod.string(),
});

export type EtherNetIPEDSFileData = zod.infer<typeof EtherNetIPEDSFileData>;
